module.exports = __webpack_public_path__ + "static/aginix-logo-social-share-b7705a70b88a16743d7e519207738004.png";